import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { stopChangeClothes } from './stopChangeClothes';
import handleGarmentSelection from '../changeClothes/handleGarmentSelection';
import handleCustomClothes from '../changeClothes/handleCustomClothes';
import { handleFilterChange, handleGenderChange } from './displayClothes';

export default function initChangeClothes() {
  // Get gender from servizio
  const servizio = getState('selected.servizio');
  const gender = servizio?.sesso || 'm';
  modifyState('changeClothesGender', gender);

  // Initialize state
  modifyState('ischangeClothesActive', false);

  // Set up event listeners for change clothes controls
  $('body').off('click', '#editor-menu-abort-change-clothes');
  $('body').on('click', '#editor-menu-abort-change-clothes', () => {
    stopChangeClothes();
  });

  // Set up custom clothes button listener
  $('body').off('click', '#btn-custom-clothes');
  $('body').on('click', '#btn-custom-clothes', () => {
    handleCustomClothes();
  });

  // Set up garment selection listener
  $('body').off('click', '[data-cloth-url]');
  $('body').on('click', '[data-cloth-url]', function () {
    const clothUrl = $(this).data('cloth-url');
    const prompt = $(this).data('prompt');

    if (clothUrl && prompt) {
      handleGarmentSelection.call(this, clothUrl, prompt);
    } else {
      console.error('Missing clothUrl or prompt for change clothes');
    }
  });

  // Initialize filters state
  modifyState('changeClothesFiltersCategory', 'all');
  modifyState('changeClothesFiltersColor', 'all');

  // Set up filter change listeners
  $('body').off('change', '#change-clothes-filter-category');
  $('body').on('change', '#change-clothes-filter-category', function () {
    const category = $(this).val();
    modifyState('changeClothesFiltersCategory', category);
    // Refresh garment display
    handleFilterChange();
  });

  $('body').off('click', '.change-clothes-color-square');
  $('body').on('click', '.change-clothes-color-square', function () {
    const color = $(this).data('color');

    // Update active state
    $('.change-clothes-color-square').removeClass('active');
    $(this).addClass('active');

    modifyState('changeClothesFiltersColor', color);
    // Refresh garment display
    handleFilterChange();
  });

  // Set up gender tab listeners
  $('body').off(
    'click',
    '[data-sidebar-tab-target-name="change-clothes-donna"]'
  );
  $('body').on(
    'click',
    '[data-sidebar-tab-target-name="change-clothes-donna"]',
    async function () {
      const currentGender = getState('changeClothesGender');
      if (currentGender !== 'f') {
        modifyState('changeClothesGender', 'f');
        modifyState('changeClothesFiltersCategory', 'all');
        modifyState('changeClothesFiltersColor', 'all');
        // Reload clothes for new gender
        await handleGenderChange();
      }
    }
  );

  $('body').off(
    'click',
    '[data-sidebar-tab-target-name="change-clothes-uomo"]'
  );
  $('body').on(
    'click',
    '[data-sidebar-tab-target-name="change-clothes-uomo"]',
    async function () {
      const currentGender = getState('changeClothesGender');
      if (currentGender !== 'm') {
        modifyState('changeClothesGender', 'm');
        modifyState('changeClothesFiltersCategory', 'all');
        modifyState('changeClothesFiltersColor', 'all');
        // Reload clothes for new gender
        await handleGenderChange();
      }
    }
  );
}
